import React from 'react';
import Modal from 'react-modal';

export default class LoadingModal extends React.Component {
    render() {
        let message = null;
        if (this.props.message === undefined && window.VULOG_CURRENT_STEP) {
            message = (
                <h4 style={{ color: 'white' }} className={'loading__message'}>
                    {window.VULOG_TRANSLATE(`${window.VULOG_CURRENT_STEP}_LOADING_MESSAGE`)}
                </h4>
            );
        }
        if (this.props.message) {
            message = (
                <h4 style={{ color: 'white' }} className={'loading__message'}>
                    {window.VULOG_TRANSLATE(this.props.message)}
                </h4>
            );
        }
        return (
            <Modal
                isOpen={this.props.loading}
                portalClassName="e-modal"
                overlayClassName="e-modal__overlay"
                className="e-modal__content"
                bodyOpenClassName="e-modal--is-open"
                htmlOpenClassName="prevent-scroll"
                shouldFocusAfterRender={false}
                ariaHideApp={false}
            >
                <div className="loading-container">
                    <i className="loading fas fa-spinner fa-spin" />
                    {message && message}
                </div>
            </Modal>
        );
    }
}
